<template>
  <v-card class="d-flex align-items-center text-center mt-4">
    <div class="w-100">

      <v-card-title class="card-title">
        Contacto
      </v-card-title>
      <v-card-text>
        <v-row class="pa-3">
          <v-col cols="12" md="4">
            <BaseInput label="Dirección" name="address" v-model="legajo.address" :rules="''"
              :validationErrors="errors" />

            <BaseCombobox label="Provincia" name="province" v-model="legajo.province" :items="provinces"
              item-text="name" item-value="id" :loading="loading_provinces" :rules="''" :validationErrors="errors" />
           
            <BaseInput label="Observaciones" name="observations" v-model="legajo.observations" :rules="''"
              :validationErrors="errors" />

          </v-col>
          <v-col cols="12" md="4">

            <BaseInput label="Código postal" name="postal_code" v-model="legajo.postal_code" :rules="''"
              :validationErrors="errors" />
            
            <BaseInput label="Email" name="email" v-model="legajo.email" :rules="''"
              :validationErrors="errors" />

          </v-col>
          <v-col cols="12" md="4">

            <BaseInput label="Localidad" name="locality" v-model="legajo.locality" :rules="''"
              :validationErrors="errors" />

            <BaseInput label="Teléfono" name="phone" v-model="legajo.phone" :rules="''"
              :validationErrors="errors" />

          
          </v-col>

        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>

import { listService } from '../../../libs/ws/listService';
import BaseInput from "@/components/BaseInput.vue";
import BaseCombobox from "@/components/BaseCombobox.vue";

export default {
  components: { BaseInput ,BaseCombobox},
  name: "CardContact",
  props: {
    legajo: {
      type: Object
    }
  },
  data() {
    return {
      provinces: [],
      loading_provinces: false,
    };
  },
  created() {

  },
  mounted() {
    this.loadProvinces();
  },
  methods: {
    async validate() {
      const valid = await this.$validator.validateAll();
      return valid;
    },
    loadProvinces() {
      this.loading_provinces = true;

      listService
        .list_provinces()
        .then((response) => {
          if (response.status)
            this.provinces = response.result;
        })
        .catch((e) => {
          console.log("categories.filter error");
          console.log(e);
        })
        .finally(() => {
          this.loading_provinces = false;
        });
    },

  },
};
</script>
